import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {notificationsPageText as notificationsPageText_en} from "../libs/en/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_en_ca} from "../libs/en-ca/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_de} from "../libs/de/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_de_ch} from "../libs/de-ch/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_fr} from "../libs/fr/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_fr_ca} from "../libs/fr-ca/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_nl} from "../libs/nl/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_it} from "../libs/it/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_it_ch} from "../libs/it-ch/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_cz} from "../libs/cz/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_fi} from "../libs/fi/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_pl} from "../libs/pl/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_se} from "../libs/se/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_no} from "../libs/no/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_dk} from "../libs/dk/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_es} from "../libs/es/texts-notifications-page-lib";
import {notificationsPageText as notificationsPageText_pt} from "../libs/pt/texts-notifications-page-lib";
import {headerText as headerText_en} from "../libs/en/texts-header-lib";
import {headerText as headerText_de} from "../libs/de/texts-header-lib";
import {headerText as headerText_de_ch} from "../libs/de-ch/texts-header-lib";
import {headerText as headerText_fr} from "../libs/fr/texts-header-lib";
import {headerText as headerText_fr_ca} from "../libs/fr-ca/texts-header-lib";
import {headerText as headerText_nl} from "../libs/nl/texts-header-lib";
import {headerText as headerText_it} from "../libs/it/texts-header-lib";
import {headerText as headerText_it_ch} from "../libs/it-ch/texts-header-lib";
import {headerText as headerText_cz} from "../libs/cz/texts-header-lib";
import {headerText as headerText_fi} from "../libs/fi/texts-header-lib";
import {headerText as headerText_pl} from "../libs/pl/texts-header-lib";
import {headerText as headerText_se} from "../libs/se/texts-header-lib";
import {headerText as headerText_no} from "../libs/no/texts-header-lib";
import {headerText as headerText_dk} from "../libs/dk/texts-header-lib";
import {headerText as headerText_es} from "../libs/es/texts-header-lib";
import {headerText as headerText_pt} from "../libs/pt/texts-header-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';

/** French notification #96 — shown only for France (`FR-FR`), not for Swiss French (`FR`). */
const notificationsFrFrOnly96Header =
    'Arrêt des anciens systèmes d\'exploitation 11/05/2026';
const notificationsFrFrOnly96Body =
    'Pour CH uniquement - Une prochaine mise à jour de l\'application CamAPS FX est à venir, veuillez noter qu\'elle ne sera ensuite pris en charge qu\'UNIQUEMENT sur des téléphones compatibles avec les capteurs exécutant les systèmes d\'exploitation suivants : Android OS 13 et versions ultérieures, et Apple iOS 18 et versions ultérieures. Après la publication de cette mise à jour, les utilisateurs de systèmes d\'exploitation INFÉRIEURS à Android OS 13 ou Apple iOS 18 ne pourront PAS METTRE À JOUR ni RÉINSTALLER CamAPS FX. Pour toute question, veuillez contacter le service client mylife-Diabetescare.';

/** Notification #94 is CH-only; fr-ch uses `FR`, France uses `FR-FR` — hide #94 for FR-FR. #96 is FR-FR-only — hide for `FR`. #103 is FR-FR-only — hide for `FR`. #115 is FR-FR-only — hide for `FR`. */
function notificationsPageTextFrForSiteLanguage(language) {
    if (language === 'FR-FR') {
        return {
            ...notificationsPageText_fr,
            header_94: '',
            body_94: '',
            header_105: '',
            body_105: '',
            header_108: '',
            body_108: '',
            header_104: '',
            body_104: '',
            header_102: '',
            body_102: '',
            header_101: '',
            body_101: '',
            header_100: '',
            body_100: '',
            header_99: '',
            body_99: '',
            header_96: notificationsFrFrOnly96Header,
            body_96: notificationsFrFrOnly96Body,
        };
    }
    if (language === 'FR') {
        return {
            ...notificationsPageText_fr,
            header_103: '',
            body_103: '',
            header_108: '',
            body_108: '',
            header_115: '',
            body_115: '',
        };
    }
    return notificationsPageText_fr;
}

class Accordion extends Component {
    constructor() {
        super();
        this._handleClick = this._handleClick.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        window.addEventListener('resize', this.resize);
        this._handleClick();
    }

    _handleClick() {
        let acc = this._acc.getElementsByClassName('accordian-title');
        for (let i = 0; i < acc.length; i++) {
            let a = acc[i];
            a.onclick = () => a.classList.toggle("active");
        }
    }

    render() {
        return (
            <div
                ref={a => this._acc = a}
                onClick={this._handleClick}>
                {this.props.children}
            </div>
        )
    }
}

export class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block1: true,
            block2: false,
            block3: false,
            language: this.props.language,
            notificationsPageText: notificationsPageText_en,
            headerText: headerText_en,
        };
        if (this.state.language === "DE") {
            this.state.notificationsPageText = notificationsPageText_de;
            this.state.headerText = headerText_de;
        } else if (this.state.language === "DE-CH") {
            this.state.notificationsPageText = notificationsPageText_de_ch;
            this.state.headerText = headerText_de_ch;
        } else if (this.state.language === "EN-CA") {
            this.state.notificationsPageText = notificationsPageText_en_ca;
            this.state.headerText = headerText_en;
        } else if (this.state.language === "FR" || this.state.language === "FR-FR") {
            this.state.notificationsPageText = notificationsPageTextFrForSiteLanguage(this.state.language);
            this.state.headerText = headerText_fr;
        } else if (this.state.language === "FR-CA") {
            this.state.notificationsPageText = notificationsPageText_fr_ca;
            this.state.headerText = headerText_fr_ca;
        } else if (this.state.language === "NL") {
            this.state.notificationsPageText = notificationsPageText_nl;
            this.state.headerText = headerText_nl;
        } else if (this.state.language === "IT") {
            this.state.notificationsPageText = notificationsPageText_it;
            this.state.headerText = headerText_it;
        } else if (this.state.language === "IT-CH") {
            this.state.notificationsPageText = notificationsPageText_it_ch;
            this.state.headerText = headerText_it_ch;
        } else if (this.state.language === "CZ") {
            this.state.notificationsPageText = notificationsPageText_cz;
            this.state.headerText = headerText_cz;
        } else if (this.state.language === "FI") {
            this.state.notificationsPageText = notificationsPageText_fi;
            this.state.headerText = headerText_fi;
        } else if (this.state.language === "PL") {
            this.state.notificationsPageText = notificationsPageText_pl;
            this.state.headerText = headerText_pl;
        } else if (this.state.language === "SE") {
            this.state.notificationsPageText = notificationsPageText_se;
            this.state.headerText = headerText_se;
        } else if (this.state.language === "NO") {
            this.state.notificationsPageText = notificationsPageText_no;
            this.state.headerText = headerText_no;
        } else if (this.state.language === "DK") {
            this.state.notificationsPageText = notificationsPageText_dk;
            this.state.headerText = headerText_dk;
        } else if (this.state.language === "ES") {
            this.state.notificationsPageText = notificationsPageText_es;
            this.state.headerText = headerText_es;
        } else if (this.state.language === "PT") {
            this.state.notificationsPageText = notificationsPageText_pt;
            this.state.headerText = headerText_pt;
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_en,
                    headerText: headerText_en,
                });
            } else
            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_en_ca,
                    headerText: headerText_en,
                });
            } else if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_de,
                    headerText: headerText_de,
                });
            } else if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_de_ch,
                    headerText: headerText_de_ch,
                });
            } else if (this.props.language === "FR" || this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageTextFrForSiteLanguage(this.props.language),
                    headerText: headerText_fr,
                });
            } else if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_fr_ca,
                    headerText: headerText_fr_ca,
                });
            } else if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_nl,
                    headerText: headerText_nl,
                });
            } else if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_it,
                    headerText: headerText_it,
                });
            } else if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_it_ch,
                    headerText: headerText_it_ch,
                });
            } else if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_cz,
                    headerText: headerText_cz,
                });
            } else if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_fi,
                    headerText: headerText_fi,
                });
            } else if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_pl,
                    headerText: headerText_pl,
                });
            } else if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_se,
                    headerText: headerText_se,
                });
            } else if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_no,
                    headerText: headerText_no,
                });
            } else if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_dk,
                    headerText: headerText_dk,
                });
            } else if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_es,
                    headerText: headerText_es,
                });
            } else if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    notificationsPageText: notificationsPageText_pt,
                    headerText: headerText_pt,
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    toggle = (index) => () => {
        this.setState({[`block${index}`]: !this.state[`block${index}`]});
    };

    toggleExpand = (expand = false) => () => {
        this.setState({
            block1: expand,
            block2: expand,
            block3: expand,
        });
    };


    render() {
        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.notificationsPageText.title)}</title>
                    <meta name="title" content={parse(this.state.notificationsPageText.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.notificationsPageText.descriptionMeta)}/>
                    <meta name="keywords" content={this.state.notificationsPageText.keywords}/>
                    <meta property="og:locale" content={this.state.notificationsPageText.localeMeta}/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-8 col-xl-9">
                                <h1>{parse(this.state.notificationsPageText.heading)}</h1>
                                {/*<p>{parse(this.state.notificationsPageText.subheading)}</p>*/}
                            </div>
                        </div>
                    </div>
                </section>
                <section className="faq-main">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <Accordion>
                                    {this.state.notificationsPageText.header_133 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_133)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_133)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_132 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_132)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_132)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_131 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_131)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_131)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_130 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_130)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_130)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_129 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_129)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_129)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_128 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_128)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_128)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_127 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_127)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_127)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_126 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_126)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_126)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_125 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_125)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_125)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_124 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_124)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_124)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_123 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_123)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_123)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_122 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_122)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_122)}</p>
                                            </div>
                                        </div>
                                    }
                                   
                                    {this.state.notificationsPageText.header_121 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_121)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_121)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_120 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_120)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_120)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_119 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_119)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_119)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_118 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_118)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_118)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_117 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_117)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_117)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_116 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_116)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_116)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_115 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_115)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_115)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_114 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_114)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_114)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_113 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_113)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_113)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_112 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_112)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_112)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_111 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_111)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_111)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_110 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_110)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_110)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_110_link)}
                                                   title={parse(this.state.notificationsPageText.body_110_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_110_link_text)}</u></a>
                                                {this.state.notificationsPageText.body_110_end ? parse(this.state.notificationsPageText.body_110_end) : null}
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_109 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_109)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_109)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_108 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_108)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_108)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_107 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_107)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_107)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_106 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_106)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_106)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_105 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_105)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_105)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_104 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_104)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_104)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_103 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_103)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_103)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_102 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_102)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_102)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_101 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_101)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_101)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_100 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_100)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_100)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_99 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_99)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_99)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_98 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_98)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_98)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_97 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_97)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_97)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_96 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_96)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_96)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_95 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_95)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_95)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_94 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_94)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_94)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_90 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_90)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_90)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_93 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_93)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_93)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_92 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_92)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_92)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_89 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_89)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_89)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_91 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_91)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_91)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_91_link)}
                                                   title={parse(this.state.notificationsPageText.body_91_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_91_link_text)}</u></a>
                                                {this.state.notificationsPageText.body_91_end ? parse(this.state.notificationsPageText.body_91_end) : null}
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_88 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_88)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_88)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_87 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_87)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_87)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_86 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_86)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_86)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_86_link)}
                                                   title={parse(this.state.notificationsPageText.body_86_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_86_link_text)}</u></a>
                                                {this.state.notificationsPageText.body_86_end ? parse(this.state.notificationsPageText.body_86_end) : null}
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_83 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_83)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_83)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_84 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_84)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_84)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_82 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_82)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_82)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_81 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_81)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_81)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_80 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_80)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_80)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_79 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_79)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_79)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_78 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_78)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_78)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_77 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_77)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_77)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_76 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_76)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_76)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_75 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_75)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_75)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_74 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_74)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_74)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_73 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_73)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_73)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_73_link)}
                                                   title={parse(this.state.notificationsPageText.body_73_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_73_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_72 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_72)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_72)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_72_link)}
                                                   title={parse(this.state.notificationsPageText.body_72_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_72_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_71 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_71)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_71)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_71_link)}
                                                   title={parse(this.state.notificationsPageText.body_71_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_71_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_70 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_70)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_70)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_70_link)}
                                                   title={parse(this.state.notificationsPageText.body_70_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_70_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_69 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_69)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_69)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_68 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_68)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_68)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_67 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_67)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_67)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_66 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_66)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_66)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_66_link)}
                                                   title={parse(this.state.notificationsPageText.body_66_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_66_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }

                                    {this.state.notificationsPageText.header_65 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_65)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_65)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_65_link)}
                                                   title={parse(this.state.notificationsPageText.body_65_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_65_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_64 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_64)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_64)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_64_link)}
                                                   title={parse(this.state.notificationsPageText.body_64_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_64_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_63 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_63)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_63)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_63_link)}
                                                   title={parse(this.state.notificationsPageText.body_63_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <u>{parse(this.state.notificationsPageText.body_63_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_62 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_62)}</h4></div>
                                            <div className="accordian-content">
                                                {parse(this.state.notificationsPageText.body_62)}
                                                &nbsp;
                                                <a href={parse(this.state.notificationsPageText.body_62_link)}
                                                   title={parse(this.state.notificationsPageText.body_62_link_text)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                <u>{parse(this.state.notificationsPageText.body_62_link_text)}</u></a>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_61 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_61)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_61)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_60 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_60)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_60)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_59 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_59)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_59)}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.notificationsPageText.header_58 &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.notificationsPageText.header_58)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.notificationsPageText.body_58)}</p>
                                            </div>
                                        </div>
                                    }
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}

